import dayjs from 'dayjs';
import basicObjectToArrayMapper from 'utils/helpers/mappers/basicObjectToArrayMapper';
import constants from 'utils/constants';
import { objectToDropdownElementMapper } from 'modules/account/contact/transformers/dataMapper';

import timezones from '../../../../data/timezones.json';

const FILTER_TYPES = {
  date: [
    {
      value: JSON.stringify({
        $gte: dayjs().startOf('day').toDate(),
        $lt: dayjs().endOf('day').toDate(),
      }),
      label: 'Today',
      description: 'Today from midnight until the current time',
    },
    {
      value: JSON.stringify({
        $gte: dayjs().subtract(1, 'd').startOf('day').toDate(),
        $lt: dayjs().subtract(1, 'd').endOf('day').toDate(),
      }),
      label: 'Yesterday',
      description: 'The previous 24 hours day',
    },
    {
      value: JSON.stringify({
        $gte: dayjs().startOf('week').toDate(),
        $lt: dayjs().endOf('week').toDate(),
      }),
      label: 'This week',
      description: 'The current calendar week',
    },
    {
      value: JSON.stringify({
        $gte: dayjs().startOf('month').toDate(),
        $lt: dayjs().endOf('month').toDate(),
      }),
      label: 'This month',
      description: 'The current calendar month',
    },
  ],
  accountUsers: [],
  activities: [
    {
      value: 'calls',
      label: 'Calls',
      description: 'Communication',
    },
    {
      value: 'conversations',
      label: 'Conversations',
      description: 'Communication',
    },
    {
      value: 'emails',
      label: 'Emails',
      description: 'Communication',
    },
    {
      value: 'linkedIn',
      label: 'LinkedIn',
      description: 'Communication',
    },
    {
      value: 'meetings',
      label: 'Meetings',
      description: 'Team Acitivity',
    },
    {
      value: 'notes',
      label: 'Notes',
      description: 'Team Acitivity',
    },
    {
      value: 'tasks',
      label: 'Tasks',
      description: 'Team Acitivity',
    },
  ],
  industry: basicObjectToArrayMapper(constants.INDUSTRIES)(
    objectToDropdownElementMapper,
  ) as {
    value: string;
    label: string;
  }[],
  dealTypes: basicObjectToArrayMapper(constants.DEAL_TYPES)(
    objectToDropdownElementMapper,
  ) as {
    value: string;
    label: string;
  }[],
  companyTypes: basicObjectToArrayMapper(constants.COMPANY_TYPES)(
    objectToDropdownElementMapper,
  ) as { value: string; label: string }[],
  timezones: basicObjectToArrayMapper(timezones)(
    objectToDropdownElementMapper,
  ) as {
    value: string;
    label: string;
  }[],
  invoiceStatus: [
    {
      value: 'DRAFT',
      label: 'Draft',
    },
    {
      value: 'UNSENT',
      label: 'Unsent',
    },
    {
      value: 'SENT',
      label: 'Sent',
    },
    {
      value: 'SKIP',
      label: 'Skip',
    },
    {
      value: 'PAID',
      label: 'Paid',
    },
    {
      value: 'OVERDUE',
      label: 'Overdue',
    },
  ],
  taskStatus: [
    {
      label: 'ALL',
      value: 'ALL',
    },
    {
      label: 'PENDING',
      value: 'PENDING',
    },
    {
      label: 'IN PROGRESS',
      value: 'IN_PROGRESS',
    },
    {
      label: 'COMPLETED',
      value: 'COMPLETED',
    },
  ],
  taskType: [
    {
      label: 'To do',
      value: 'TODO',
    },
    {
      label: 'Email',
      value: 'EMAIL',
    },
    {
      label: 'Call',
      value: 'CALL',
    },
  ],
  accountStatus: [
    {
      label: 'Free Trial',
      value: 'TRIAL',
    },
    {
      label: 'Subscribed',
      value: 'PAID',
    },
    {
      label: 'Cancelled',
      value: 'EXPIRED',
    },
  ],
  ticketStatus: [
    {
      label: 'Open',
      value: 'OPEN',
    },
    {
      label: 'In Progress',
      value: 'IN_PROGRESS',
    },
    {
      label: 'Closed',
      value: 'CLOSED',
    },
  ],
};

export default FILTER_TYPES;
